import { render, staticRenderFns } from "./ListaAdminDirectorio.vue?vue&type=template&id=669622aa"
import script from "./ListaAdminDirectorio.vue?vue&type=script&lang=js"
export * from "./ListaAdminDirectorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports